import { render, staticRenderFns } from "./ipAddressListItem.vue?vue&type=template&id=4fe38c10"
import script from "./ipAddressListItem.vue?vue&type=script&lang=js"
export * from "./ipAddressListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports